"use strict";

var Tariff = function () {

  var set_fcl_div = function() {
    if ($('#tariff_has_fcl_prices').is(':checked')) {
      $('#vehicle').show();
    } else {
      $('#vehicle').hide();
    }
  }

  var set_lcl_div = function() {
    if ($('#tariff_has_lcl_prices').is(':checked')) {
      $('#unit_scales').show();
      $('#unit').show();
    } else {
      $('#unit_scales').hide();
      $('#unit').hide();
    }
  }

  var set_load_type_div = function() {
    var load_type = $("#tariff_load_type").val();
    if (load_type == "complete")  {
      $('#unit_scales').hide();
      $('#unit').hide();
      $('#vehicle').show();
    } else if (load_type == "partial") {
      $('#unit_scales').show();
      $('#unit').show();
      $('#vehicle').hide();
    }
    else {
      $('#unit_scales').hide();
      $('#unit').hide();
      $('#vehicle').hide();
    }
  }

  var set_company_fields = function() {
    if ($('#tariff_tariff_type').val() == "general") {
      $(".tariff_supplier_id").hide();
      $(".tariff_agent_id").hide();
    } else {
      $(".tariff_supplier_id").show();
      $(".tariff_agent_id").show();
    }
  }

  var set_debit_credit_fields = function() {
    if ($('#tariff_debit_credit').val() == "credit") {
      $(".tariff_supplier_id").show();
      $(".tariff_agent_id").hide();
      $(".tariff_tariff_type").hide();
    } else {
      $(".tariff_supplier_id").show();
      $(".tariff_agent_id").show();
      $(".tariff_tariff_type").show();
    }
  }
  
  var set_departure_fields = function() {
    var place_type = $("#tariff_departure_location_type").val();
    if (place_type === "zone") {
      $('.tariff_departure_zone').show();
      $('.tariff_departure_place').hide();
      $('.tariff_departure_city').hide();
      $('.tariff_departure_region').hide();
    } else if (place_type === "city") {
      $('.tariff_departure_city').show();
      $('.tariff_departure_place').hide();
      $('.tariff_departure_zone').hide();
      $('.tariff_departure_region').hide();
    } else if (place_type === "region") {
      $('.tariff_departure_region').show();
      $('.tariff_departure_place').hide();
      $('.tariff_departure_city').hide();
      $('.tariff_departure_zone').hide();
    } else {
      $('.tariff_departure_place').show();
      $('.tariff_departure_zone').hide();
      $('.tariff_departure_city').hide();
      $('.tariff_departure_region').hide();
    }
  }

  var set_arrival_fields = function() {
    var place_type = $("#tariff_arrival_location_type").val();
    if (place_type === "zone") {
      $('.tariff_arrival_zone').show();
      $('.tariff_arrival_place').hide();
      $('.tariff_arrival_city').hide();
      $('.tariff_arrival_region').hide();
    } else if (place_type === "city") {
      $('.tariff_arrival_city').show();
      $('.tariff_arrival_place').hide();
      $('.tariff_arrival_zone').hide();
      $('.tariff_arrival_region').hide();
    } else if (place_type === "region") {
      $('.tariff_arrival_region').show();
      $('.tariff_arrival_place').hide();
      $('.tariff_arrival_city').hide();
      $('.tariff_arrival_zone').hide();
    } else {
      $('.tariff_arrival_place').show();
      $('.tariff_arrival_zone').hide();
      $('.tariff_arrival_city').hide();
      $('.tariff_arrival_region').hide();
    }
  }

  var toggle_profit_rate = function() {
    var trans_method = $("#tariff_trans_method").val()
    if (trans_method === "customs"){
      if ($("#tariff_unit_scales").val() === "percentage"){
        $("#profit_rate").show();
      }else{
        $("#profit_rate").hide();
        $("#tariff_profit_rate").val(0);
      }
    }
  }

  return {
    init: function () {
      $(document).on("change", "#tariff_has_fcl_prices", function() {
        set_fcl_div();
      });
      set_fcl_div();

      $(document).on("change", "#tariff_has_lcl_prices", function() {
        set_lcl_div();
      });
      set_lcl_div();

      $(document).on("change", "#tariff_load_type", function() {
        set_load_type_div();
      });
      set_load_type_div();

      $(document).on("change", "#tariff_departure_location_type", function(event) {
        set_departure_fields();
      });
      set_departure_fields();

      $(document).on("change", "#tariff_arrival_location_type", function(event) {
        set_arrival_fields();
      });
      set_arrival_fields();

      $(document).on("change", "#tariff_tariff_type", function(event) {
        set_company_fields();
      });
      set_company_fields();

      $(document).on("change", "#tariff_debit_credit", function(event) {
        set_debit_credit_fields();
      });
      set_debit_credit_fields();
      $(document).on("change", "#tariff_unit_scales", function(event) {
        toggle_profit_rate();
      });
      toggle_profit_rate();
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Tariff;
}